// Module
var code = "<div class=\"product-3d-view\"> <iframe id=\"{{ $ctrl.id }}\" ng-src=\"{{ $ctrl.iframeSrc }}\" frameBorder=\"0\" loading=\"lazy\" width=\"500\" height=\"500\"></iframe> </div> ";
// Exports
module.exports = code;